import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/style.scss";
import React, { useEffect } from "react";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import pages from "./pages";
import Interceptor from "./API/Interceptor/Interceptor";
import PageLoader from './layout/pageloader'
import Dashboard from "./pages/Dashboard";
import { QueryClient, QueryClientProvider } from "react-query";
import ProtectedRoute from "./Common/ProtectedRoute";
import FocRequest from "./pages/Foc";
import { createBrowserHistory } from "history";
import { setFilter } from "./store/slices/propertySlice";
import { useDispatch, useSelector } from "react-redux";
import UserRoutes from "./Common/UserRoutes";
import FoodInvoiceBill from "pages/foodinvoice/FoodInvoice";
import ReactGA from "react-ga4";
import GrcDownload from "pages/Dashboard/AllBookings/components/GrcDownload";
import { getFirebaseToken, onNotificationListener } from "./firebase-messaging";
import axios from "axios";
import { authenticationSeletor } from "./store/slices/authenticationSlice";
import notificationSound from './notification.mp3';
import NotificationPopup from './components/NotificationPopup';
import { baseUrl } from "API/client/api";

ReactGA.initialize("G-S9FK919WJH");

const {
  Home,
  Login,
  Register,
  Property,
  Propertydetails,
  Payment,
  AdminLogin,
  RRoomsUsers,
  PropertyCategory,
  RoomCategory,
  PropertyUsers,
  Amenities,
  Customer,
  CustomerEnquiry,
  CreateInventory,
  CheckInventory,
  CreateInventorySupplier,
  CreateInventoryItem,
  InventoryCategory,
  FoodCategory,
  FoodsItems,
  FoodsOrders,
  CouponPage,
  CustomerReviews,
  TaxSettings,
  RoomPriceSetting,
  RoomRateManager,
  MenuCard,
  NcTypeSetting,
  LaundryProvider,
  LaundryService,
  Laundry,
  UserLogins,
  SearchResult,
  Invoice,
  RoomPrice,
  CancellationRefundPolicy,
  MenuCategory,
  BreakFast,
  FoodInvoice,
  BookingReport,
  RoomOccupancyReport,
  RevenuesReport,
  MealPlanReport,
  ExpensesReport,
  GuestReport,
  RatingReport,
  TransactionReport,
  NewTransactionReport,
  PaymentReport,
  ManageRoles,
  FoodReport,
  FoodPaymentReport,
  FoodItemsReport,
  CityLocality,
  ExpensesCategory,
  SeoUpdate,
  HotelSummery,
  InventoryReport,
  InvoiceDownload,
  Sale,
  InvoiceFinance,
  InvoicePayment,
  ModuleConfiguration,
  ResturantOrders,
  ResturantMenu,
  ResturantTable,
  ResturantPayment,
  BunquetFunction,
  BunquetBookings,
  BunquetInvoice,
  BunquetPayment,
  AgreementProperty,
  GuestDetails,
  BanquetMenu,
  BunquetEnquiry,
  AddBunquetBookings,
  ModuleConfigurationAdmin,
  BunquetBookingDetails,
  Expenses,
  DSRPage,
  RevenueReport,
  PropertyInquery,
  Unauthorized,
  KotLogs,
  PropertyLogs,
  TAEnquiries,
  TaLedgerReport,
  PropertyReport
} = pages;

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const history = createBrowserHistory();
  const queryClient = new QueryClient();
  const { userDetail } = useSelector(authenticationSeletor);
  let pageLoader = useSelector((state) => state?.loaders?.loading)

  useEffect(() => {
    const userId = userDetail?.id;
    getFirebaseToken().then(token => {
      if (token) {
        axios.post(`${baseUrl}/auth/property-user-save-token`, {
          userId,
          fcmToken: token
        }).then(res => {
        }).catch(err => {
        });
      } else {
      }
    });
    onNotificationListener().then(payload => {
      const audio = new Audio(notificationSound);
      audio.play();
      alert(`${payload.notification.title}: ${payload.notification.body}`);
    });
  }, [userDetail]);

  useEffect(() => {
    let getLocation = history.location.pathname;
    if (getLocation != "/hotel-listings") { dispatch(setFilter({ propertyCategoryFilter: [], roomCategoryFilter: [], amenitiesFilter: [] })); }
  }, [history]);

  const propertyId = userDetail?.propertyId;

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.type === "PLAY_SOUND") {
          const audio = new Audio("/notification.mp3");
          audio.play().catch((err) => console.log("Autoplay blocked:", err));
        }
      });
    }
  }, []);

  return (
    <div className="App">
      <div style={{ position: 'fixed', left: '0px', zIndex: '999' }}>
        {/* <button on  Click={playNotificationSound}>Test Notification Sound</button> */}
      </div>
      <Interceptor />
      {/* {userDetail?.propertyId > 0 && <NotificationRing userDetail={userDetail} />} */}
      <NotificationPopup propertyId={propertyId} />

      {pageLoader && <PageLoader />}
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/payment" element={<UserRoutes><Payment /></UserRoutes>} />
          <Route path="/property-agreement-accept/:id" element={<AgreementProperty />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/booking/download-grc/:id" element={<ProtectedRoute allowedFor={["propertyUser"]}><GrcDownload /></ProtectedRoute>} />
          <Route path="/property-details/:id" element={<ProtectedRoute allowedFor={["rroomUser"]}><Property /></ProtectedRoute>} />
          <Route path="/property-listing" element={<ProtectedRoute allowedFor={["rroomUser"]}><Propertydetails /></ProtectedRoute>} />
          <Route path="/rrooms-users" element={<ProtectedRoute allowedFor={["rroomUser"]}><RRoomsUsers /></ProtectedRoute>} />
          <Route path="/rrooms/module-configuration" element={<ProtectedRoute allowedFor={["rroomUser"]}><ModuleConfigurationAdmin /></ProtectedRoute>} />
          <Route path="/manage-roles" element={<ProtectedRoute allowedFor={["rroomUser"]}><ManageRoles /></ProtectedRoute>} />
          <Route path="/property-category" element={<ProtectedRoute allowedFor={["rroomUser"]}><PropertyCategory /></ProtectedRoute>} />
          <Route path="/room-category" element={<ProtectedRoute allowedFor={["rroomUser"]}><RoomCategory /></ProtectedRoute>} />
          <Route path="/property-users" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><PropertyUsers /></ProtectedRoute>} />
          <Route path="/ta-enquiries" element={<ProtectedRoute allowedFor={["rroomUser"]}><TAEnquiries /></ProtectedRoute>} />
          <Route path="/amenities" element={<ProtectedRoute allowedFor={["rroomUser"]}><Amenities /></ProtectedRoute>} />
          <Route path="/customer" element={<ProtectedRoute allowedFor={["rroomUser"]}><Customer /></ProtectedRoute>} />
          <Route path="/enquiry-customer" element={<ProtectedRoute allowedFor={["rroomUser"]}><CustomerEnquiry /></ProtectedRoute>} />
          <Route path="/create-inventory" element={<ProtectedRoute allowedFor={["propertyUser"]}><CreateInventory /></ProtectedRoute>} />
          <Route path="/check-inventory" element={<ProtectedRoute allowedFor={["propertyUser"]}><CheckInventory /></ProtectedRoute>} />
          <Route path="/inventory-supplier" element={<ProtectedRoute allowedFor={["propertyUser"]}><CreateInventorySupplier /></ProtectedRoute>} />
          <Route path="/inventory-item" element={<ProtectedRoute allowedFor={["propertyUser"]}><CreateInventoryItem /></ProtectedRoute>} />
          <Route path="/inventory-category" element={<ProtectedRoute allowedFor={["propertyUser"]}><InventoryCategory /></ProtectedRoute>} />
          <Route path="/food-category" element={<ProtectedRoute allowedFor={["propertyUser"]}><FoodCategory /></ProtectedRoute>} />
          <Route path="/food-items" element={<ProtectedRoute allowedFor={["propertyUser"]}><FoodsItems /></ProtectedRoute>} />
          <Route path="/kitchen-logs" element={<ProtectedRoute allowedFor={["propertyUser"]}><KotLogs /></ProtectedRoute>} />
          <Route path="/food-orders" element={<ProtectedRoute allowedFor={["propertyUser"]}><FoodsOrders /></ProtectedRoute>} />
          <Route path="/restaurant/Restaurant-food-orders" element={<ProtectedRoute allowedFor={["propertyUser"]}><ResturantOrders /></ProtectedRoute>} />
          <Route path="/restaurant/Restaurant-food-orders/:id" element={<ProtectedRoute allowedFor={["propertyUser"]}><ResturantOrders /></ProtectedRoute>} />
          <Route path="/restaurant/Restaurant-menu-mangement" element={<ProtectedRoute allowedFor={["propertyUser"]}><ResturantMenu /></ProtectedRoute>} />
          <Route path="/restaurant/Restaurant-table-mangement" element={<ProtectedRoute allowedFor={["propertyUser"]}><ResturantTable /></ProtectedRoute>} />
          <Route path="/restaurant/Restaurant-payment" element={<ProtectedRoute allowedFor={["propertyUser"]}><ResturantPayment /></ProtectedRoute>} />
          <Route path="/banquet/banquet-function-type" element={<ProtectedRoute allowedFor={["propertyUser"]}><BunquetFunction /></ProtectedRoute>} />
          <Route path="/banquet/banquet-menu-item" element={<ProtectedRoute allowedFor={["propertyUser"]}><BanquetMenu /></ProtectedRoute>} />
          <Route path="/banquet/banquet-enquiry" element={<ProtectedRoute allowedFor={["propertyUser"]}><BunquetEnquiry /></ProtectedRoute>} />
          <Route path="/banquet/banquet-bookings-enquiry/:id" element={<ProtectedRoute allowedFor={["propertyUser"]}><BunquetEnquiry /></ProtectedRoute>} />
          <Route path="/banquet/banquet-bookings" element={<ProtectedRoute allowedFor={["propertyUser"]}><BunquetBookings /></ProtectedRoute>} />
          <Route path="/banquet/banquet-bookings-report/:id" element={<ProtectedRoute allowedFor={["propertyUser"]}><BunquetBookings /></ProtectedRoute>} />
          <Route path="/banquet/banquet-bookings/details/:id" element={<ProtectedRoute allowedFor={["propertyUser"]}><BunquetBookingDetails /></ProtectedRoute>} />
          <Route path="/banquet/add-banquet-bookings/:banquetId?" element={<ProtectedRoute allowedFor={["propertyUser"]}><AddBunquetBookings /></ProtectedRoute>} />
          <Route path="/banquet/banquet-invoice" element={<ProtectedRoute allowedFor={["propertyUser"]}><BunquetInvoice /></ProtectedRoute>} />
          <Route path="/banquet/banquet-payment" element={<ProtectedRoute allowedFor={["propertyUser"]}><BunquetPayment /></ProtectedRoute>} />
          <Route path="/accounts/expenses" element={<ProtectedRoute allowedFor={["propertyUser"]}><Expenses /></ProtectedRoute>} />
          <Route path="/accounts/dsr" element={<ProtectedRoute allowedFor={["propertyUser"]}><DSRPage /></ProtectedRoute>} />
          <Route path="/accounts/revenue-report" element={<ProtectedRoute allowedFor={["propertyUser"]}><RevenueReport /></ProtectedRoute>} />
          <Route path="/breakfast" element={<ProtectedRoute allowedFor={["propertyUser"]}><BreakFast /></ProtectedRoute>} />
          <Route path="/coupon" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><CouponPage /></ProtectedRoute>} />
          <Route path="/customer-reviews" element={<ProtectedRoute allowedFor={["propertyUser"]}><CustomerReviews /></ProtectedRoute>} />
          <Route path="/tax-setting" element={<ProtectedRoute allowedFor={["rroomUser"]}><TaxSettings /></ProtectedRoute>} />
          <Route path="/logs" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><PropertyLogs /></ProtectedRoute>} />
          <Route path="/roomprice-setting" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><RoomRateManager /></ProtectedRoute>} />
          <Route path="/hotel-finance/summary" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><HotelSummery /></ProtectedRoute>} />
          <Route path="/hotel-finance/sale" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><Sale /></ProtectedRoute>} />
          <Route path="/hotel-finance/invoice-formate/:id/:propertyId" element={<ProtectedRoute allowedFor={["propertyUser"]}><InvoiceDownload /></ProtectedRoute>} />
          <Route path="/hotel-finance/invoice" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><InvoiceFinance /></ProtectedRoute>} />
          <Route path="/property-users/module-configuration/:id" element={<ProtectedRoute allowedFor={["propertyUser"]}><ModuleConfiguration /></ProtectedRoute>} />
          <Route path="/invoice-payment-confirm/:id" element={<ProtectedRoute allowedFor={["propertyUser"]}><InvoicePayment /></ProtectedRoute>} />
          <Route path="/nc-type-setting" element={<ProtectedRoute allowedFor={["propertyUser"]}><NcTypeSetting /></ProtectedRoute>} />
          <Route path="/menu-card" element={<ProtectedRoute allowedFor={["propertyUser"]}><MenuCard /></ProtectedRoute>} />
          <Route path="/laundry-provider" element={<ProtectedRoute allowedFor={["propertyUser"]}><LaundryProvider /></ProtectedRoute>} />
          <Route path="/laundry-service" element={<ProtectedRoute allowedFor={["propertyUser"]}><LaundryService /></ProtectedRoute>} />
          <Route path="/laundry" element={<ProtectedRoute allowedFor={["propertyUser"]}><Laundry /></ProtectedRoute>} />
          <Route path="/foc-request" element={<ProtectedRoute allowedFor={["propertyUser"]}><FocRequest /></ProtectedRoute>} />
          <Route path="/user-logins" element={<ProtectedRoute allowedFor={["propertyUser"]}><UserLogins /></ProtectedRoute>} />
          <Route path="/dashboard/guest-details" element={<ProtectedRoute allowedFor={["propertyUser"]}><GuestDetails /></ProtectedRoute>} />
          <Route path="/search-result" element={<ProtectedRoute allowedFor={["rroomUser"]}><SearchResult /></ProtectedRoute>} />
          <Route path="/Invoice" element={<ProtectedRoute allowedFor={["propertyUser"]}><Invoice /></ProtectedRoute>} />
          <Route path="/Food-Invoice" element={<ProtectedRoute allowedFor={["propertyUser"]}><FoodInvoice /></ProtectedRoute>} />
          <Route path="/Food-Invoice-Bill" element={<ProtectedRoute allowedFor={["propertyUser"]}><FoodInvoiceBill /></ProtectedRoute>} />
          <Route path="/room-price" element={<ProtectedRoute allowedFor={["rroomUser"]}><RoomPrice /></ProtectedRoute>} />
          <Route path="/menu-category" element={<ProtectedRoute allowedFor={["rroomUser"]}><MenuCategory /></ProtectedRoute>} />
          <Route path="/booking-report" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><BookingReport /></ProtectedRoute>} />
          <Route path="/room-occupancy-report" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><RoomOccupancyReport /></ProtectedRoute>} />
          <Route path="/revenue-report" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><RevenuesReport /></ProtectedRoute>} />
          <Route path="/report/rating-report" element={<ProtectedRoute allowedFor={["rroomUser"]}><RatingReport /></ProtectedRoute>} />
          <Route path="/report/ta-ledger-report" element={<ProtectedRoute allowedFor={["rroomUser"]}><TaLedgerReport /></ProtectedRoute>} />
          <Route path="/report/property-report" element={<ProtectedRoute allowedFor={["rroomUser"]}><PropertyReport /></ProtectedRoute>} />
          {/* <Route path="/report/transaction-report"element={<ProtectedRoute allowedFor={["rroomUser"]}><TransactionReport /></ProtectedRoute>}/> */}
          <Route path="/report/transaction-report" element={<ProtectedRoute allowedFor={["rroomUser"]}><NewTransactionReport /></ProtectedRoute>} />
          <Route path="/payment-report" element={<ProtectedRoute allowedFor={["rroomUser", "propertyUser"]}><PaymentReport /></ProtectedRoute>} />
          <Route path="/food-report" element={<ProtectedRoute allowedFor={["propertyUser"]}><FoodReport /></ProtectedRoute>} />
          <Route path="/food-payment-report" element={<ProtectedRoute allowedFor={["propertyUser"]}><FoodPaymentReport /></ProtectedRoute>} />
          <Route path="/food-items-report" element={<ProtectedRoute allowedFor={["propertyUser"]}><FoodItemsReport /></ProtectedRoute>} />
          <Route path="/meal-plan-report" element={<ProtectedRoute allowedFor={["propertyUser"]}><MealPlanReport /></ProtectedRoute>} />
          <Route path="/expenses-report" element={<ProtectedRoute allowedFor={["propertyUser"]}><ExpensesReport /></ProtectedRoute>} />
          <Route path="/guest-report" element={<ProtectedRoute allowedFor={["propertyUser"]}><GuestReport /></ProtectedRoute>} />
          <Route path="/inventory-report" element={<ProtectedRoute allowedFor={["propertyUser"]}><InventoryReport /></ProtectedRoute>} />
          <Route path="/city-locality" element={<ProtectedRoute allowedFor={["rroomUser"]}><CityLocality /></ProtectedRoute>} />
          <Route path="/expenses-category" element={<ProtectedRoute allowedFor={["rroomUser"]}><ExpensesCategory /></ProtectedRoute>} />
          <Route path="/seo-update" element={<ProtectedRoute allowedFor={["rroomUser"]}><SeoUpdate /></ProtectedRoute>} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/* </ProtectedRoute> */}
      </QueryClientProvider>
    </div>
  );
}

export default App;

export const NotFound = () => { return (<><h1>Page not found</h1><Link to={"/"}>Go To Home Page</Link></>) };
